(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["whole-shop-bundle-video-mockup-hero"] && !Shopify.designMode) return;
  try {
    
  const initializeWholeShopVideoHeroes = (scope = document) => {
    scope.querySelectorAll('[data-wsb-video-hero]').forEach((root) => {
      if (root.dataset.videoHeroInitialized === 'true') return;
      root.dataset.videoHeroInitialized = 'true';

      root.querySelectorAll('[data-video-toggle]').forEach((button) => {
        button.addEventListener('click', async () => {
          const card = button.closest('[data-video-card]');
          const video = card?.querySelector('video');
          if (!card || !video) return;

          if (video.paused) {
            root.querySelectorAll('[data-video-card]').forEach((otherCard) => {
              if (otherCard === card) return;
              const otherVideo = otherCard.querySelector('video');
              if (otherVideo) otherVideo.pause();
              otherCard.dataset.playing = 'false';
              const otherButton = otherCard.querySelector('[data-video-toggle]');
              if (otherButton) otherButton.setAttribute('aria-label', otherButton.dataset.playLabel || '');
            });

            try {
              await video.play();
              card.dataset.playing = 'true';
              button.setAttribute('aria-label', button.dataset.pauseLabel || '');
            } catch {
              card.dataset.playing = 'false';
            }
          } else {
            video.pause();
            card.dataset.playing = 'false';
            button.setAttribute('aria-label', button.dataset.playLabel || '');
          }
        });
      });

      root.querySelectorAll('video').forEach((video) => {
        video.addEventListener('ended', () => {
          const card = video.closest('[data-video-card]');
          const button = card?.querySelector('[data-video-toggle]');
          if (card) card.dataset.playing = 'false';
          if (button) button.setAttribute('aria-label', button.dataset.playLabel || '');
        });
      });
    });
  };

  initializeWholeShopVideoHeroes();
  document.addEventListener('shopify:section:load', (event) => initializeWholeShopVideoHeroes(event.target));

  } catch(e) { console.error(e); }
})();
})();
